/** 浏览器端的文件下载与读取小工具。 */

export function downloadJson(filename: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  // 立刻 revoke 会让部分浏览器来不及取数据，延后一拍更稳。
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export interface PickedFile {
  name: string;
  text: string;
}

/** 打开系统文件选择框并读取文本内容；用户取消时返回 null。 */
export function pickTextFile(accept = '.json,application/json'): Promise<PickedFile | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.style.display = 'none';

    let settled = false;
    const finish = (value: PickedFile | null) => {
      if (settled) return;
      settled = true;
      input.remove();
      resolve(value);
    };

    input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (!file) {
        finish(null);
        return;
      }
      void file
        .text()
        .then((text) => finish({ name: file.name, text }))
        .catch(() => finish(null));
    });

    // 用户直接关闭选择框时不会触发 change，用窗口重新聚焦兜底
    window.addEventListener(
      'focus',
      () => {
        window.setTimeout(() => {
          if (!input.files || input.files.length === 0) finish(null);
        }, 500);
      },
      { once: true },
    );

    document.body.append(input);
    input.click();
  });
}
